import { useSite } from "@saleor/pageManage/queries";
import React from "react";
import { useMemo } from "react";
interface PageManageProps {
  params: string;
}
const PageManage: React.FC<PageManageProps> = ({}) => {
  const { data } = useSite({});
  const uri = useMemo(() => {
    if (data) {
      const lng_code = JSON.parse(localStorage.getItem("lng_code"));
      return (
        data?.shop?.shopViewPageManageUri +
        `?shop_platform=${data.shop.name}&shop_language=${lng_code}`
      );
    }
  }, [data]);
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 110px)",
        display: "block",
        border: "no"
      }}
    >
      {uri && (
        <iframe src={uri} width="100%" height="100%" frameBorder="no"></iframe>
      )}
    </div>
  );
};
export default PageManage;
